import React from 'react';
import { IconType } from 'react-icons';
import { formatCurrencyCompact } from '@/utils/formatters';

interface QuickStatsCardProps {
  title: string;
  value: number | string;
  currency?: string;
  icon: IconType;
  iconColor?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  loading?: boolean;
}

const QuickStatsCard: React.FC<QuickStatsCardProps> = ({
  title,
  value,
  currency,
  icon: Icon,
  iconColor = 'text-primary-600',
  trend,
  loading = false,
}) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-3 shadow-sm dark:border-gray-800 dark:bg-gray-900 sm:p-5">
      <div className="mb-2 flex items-center justify-between">
        <div className={`rounded-full bg-slate-100 p-2 dark:bg-gray-800 sm:p-3 ${iconColor}`}>
          <Icon size={18} />
        </div>
        {trend && (
          <span
            className={`text-xs font-medium sm:text-sm ${
              trend.isPositive
                ? 'text-green-600 dark:text-green-400'
                : 'text-red-600 dark:text-red-400'
            }`}
          >
            {trend.isPositive ? '+' : ''}
            {trend.value}%
          </span>
        )}
      </div>

      <h3 className="mb-0.5 text-[11px] font-medium leading-tight text-slate-600 dark:text-gray-400 sm:mb-1 sm:text-sm">{title}</h3>

      {loading ? (
        <div className="h-7 animate-pulse rounded bg-slate-200 dark:bg-gray-700 sm:h-8" />
      ) : (
        <p className="truncate text-lg font-bold text-slate-900 dark:text-white sm:text-2xl">
          {typeof value === 'number' && currency
            ? formatCurrencyCompact(value, currency as any)
            : value}
        </p>
      )}
    </div>
  );
};

export default QuickStatsCard;
